// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_SubscriptionSyncResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_SubscriptionSyncResponse — result of
 * POST /subscriptions/admin/subscriptions/{id}/sync (#27).
 *
 * Only reached on a run SubscriptionReconciliationService::reconcile() did
 * NOT refuse — a refusal never reaches this contract, it leaves through
 * sendError() (see admin.php::subscription_sync). Each row in `rows` is a
 * per-remote-charge OUTCOME the reconciler produced by synthesizing the same
 * NormalizedWebhookEvent a real webhook would have produced and routing it
 * through the same WebhookEventRouter — see the service's own docblock for
 * the architecture this response is reporting on.
 *
 * `truncated=true` means the provider said there was more charge history than
 * the reconciler's page cap reads — never silently treated as "fully
 * reconciled".
 */
import type { Subscriptions_SubscriptionSyncRow } from './Subscriptions_SubscriptionSyncRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_SubscriptionSyncResponseDados {
subscription_id: number
provider: string
provider_subscription_id: string
truncated: boolean
rows: Subscriptions_SubscriptionSyncRow[]
}

export type Subscriptions_SubscriptionSyncResponse = ApiResponse<Subscriptions_SubscriptionSyncResponseDados>;

registerResponseContract('Subscriptions_SubscriptionSyncResponse', {
  subscription_id:          { type: 'number',  required: true },
  provider:                 { type: 'string',  required: false },
  provider_subscription_id: { type: 'string',  required: false },
  truncated:                { type: 'boolean', required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      charge_id:     { type: 'string',  required: false },
      remote_status: { type: 'string',  required: false },
      action:        { type: 'string',  required: false },
      detail:        { type: 'string',  required: false },
      lane:          { type: 'string',  required: false },
    },
  },
})
